import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import Button from "../../components/CustomButtons/Button";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomDateField from "components/UpdateUi/CustomDateField";
import CustomSelect from "components/UpdateUi/CustomeSelect";
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
} from "@material-ui/core";

import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import { formatAmount } from "utils/Utils";
import { toCamelCase } from "utils/Utils";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";
import ToastModal from "views/components/ToastModal";
const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  card: {
    margin: "24px 0 0",
    borderRadius: 14,
    border: "1px solid #E8ECEF",
    background: "#fff",
    overflow: "hidden",
    width: "98%",
  },

  cardHeader: {
    padding: "22px 28px",
    display: "flex",
    alignItems: "center",
    gap: 18,
    borderBottom: "1px solid #ECECEC",
  },

  headerIcon: {
    width: 52,
    height: 52,
    borderRadius: 12,
    background: "#ECF9F1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#1AA15F",
  },

  title: {
    fontWeight: 700,
    fontSize: 20,
    color: "#102A43",
  },

  subtitle: {
    color: "#7B8794",
    marginTop: 3,
    fontSize: 14,
  },

  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",

    "@media(max-width:900px)": {
      gridTemplateColumns: "1fr",
    },
  },

  summaryItem: {
    display: "flex",
    alignItems: "center",
    padding: 12,
    borderBottom: "1px solid #ECECEC",
    borderRight: "1px solid #ECECEC",
    "@media(max-width:900px)": {
      borderRight: "none !important",
    },
  },

  iconCircle: {
    width: 52,
    height: 52,
    borderRadius: 12,
    background: "#F0FBF5",
    color: "#18A558",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 18,
  },

  label: {
    color: "#5F6C7B",
    fontSize: 15,
  },

  value: {
    fontWeight: 700,
    fontSize: 22,
    color: "#14213D",
    marginTop: 4,
  },

  tableHead: {
    background: "#EEF4FB",

    "& th": {
      fontWeight: 700,
      color: "#23395B",
      fontSize: 15,
    },
  },

  tableCell: {
    fontSize: 15,
    padding: "18px 20px",
    borderBottom: "1px solid #ECECEC",
  },

  totalRow: {
    background: "#EEF9F2",
    padding: "18px 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: 700,
    fontSize: 22,
    color: "#0A9A4A",
  },
}));

const LoanTenureDetails = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const [loanAmount, setLoanAmount] = useState("");
  const [maxLoanAmount, setMaxLoanAmount] = useState("");
  const [schemeList, setSchemeList] = useState([]);
  const [schemeDetails, setSchemeDetails] = useState([]);
  const [tenure, setTenure] = useState("");
  const [tenureType, setTenureType] = useState("");
  const [loanScheme, setLoanScheme] = useState("");
  const [rateOfInterest, setRateOfInterest] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const { mobileNumber } = useSelector((state) => state.login.userData);
  const [disaledFields, setDisabledFields] = useState(false);
  const [transferToBank, setTransferTobank] = useState("");
  const [totalCharges, setTotalCharges] = useState("");
  const [loanChargesTableData, setLoanChargesTableData] = useState([]);
  const [totalInterest, setTotalInterest] = useState("");
  const [maturityDate, setMaturityDate] = useState(null);
  const loanData = JSON.parse(localStorage.getItem("loanData") || "{}"); // need tp remove dummy data
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  console.log(leadId, "flaljdfkjadjk");
  useEffect(() => {
    // if (leadId) {
    fetLoanDetails();
    // }
  }, [leadId]);

  const fetLoanDetails = async (reRender = true, maturityTenure, maturityTenureType) => {
    setCallInProgress(true);
    const query = !reRender ? `?tenure=${maturityTenure}&tenureType=${maturityTenureType}` : ""
    const result = await apiHandler({
      url: endpoint.GET_LOAN_REPAYMENT_DETAILS_API + leadId + query,
      method: "POST",
      authToken: authToken,
    });

    setCallInProgress(false);

    console.log(result?.data, "result");

    if (result?.data?.loanAmount) {
      const savedLoanAmount = result.data.loanAmount;
      const savedSchemeCode = result.data.schemeCode;
      setLoanAmount(savedLoanAmount);
      setMaxLoanAmount(savedLoanAmount);
      setLoanScheme(savedSchemeCode);
      setTenure(result?.data?.tenure);
      setTenureType(result?.data?.tenureType);
      setRateOfInterest(result?.data?.interestRate);
      setTotalInterest(result?.data?.interestAmount);

      if (reRender) {
        await getLoanAmountSchemeDetails(savedLoanAmount, savedSchemeCode);
        await getLoanMaturityDate(savedSchemeCode, savedLoanAmount);
      }
    }

    if (result?.data?.error_code) {
      fetchLoanSummary();
    }
  };
  const getCustomerCibil = async () => {
    try {
      const result = await apiHandler({
        url: endpoint.GET_CUSTOMER_CIBIL + leadId,
        method: "GET",
        authToken: authToken,
      });
    
      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
        return null;
      }
    
      const cibilTenure = result?.data?.tenure;
      const cibilTenureType = result?.data?.tenureType;
    
      console.log(
        cibilTenure,
        cibilTenureType,
        "CIBIL TENURE"
      );
    
      return {
        tenure: cibilTenure,
        tenureType: cibilTenureType,
      };
    } catch (error) {
      console.error("GET_CUSTOMER_CIBIL error:", error);
      return null;
    }
  };
  const fetchLoanSummary = async (fetchCharges) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_USER_LOAN_AMOUNT_DETAILS_API + leadId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.loanAmount) {
      const acutalAmount =
        result?.data?.loanAmount > 0
          ? result?.data?.loanAmount
          : loanData?.loanAmount;
      if (Number(fetchCharges) > 0) {
        getLoanAmountSchemeDetails(fetchCharges);
      } else {
        getLoanAmountSchemeDetails(acutalAmount);
        setMaxLoanAmount(acutalAmount);
        setLoanAmount(acutalAmount);
      }
    } else {
      toastUpdate("Error", result?.data?.user_description, true);
    }
  };
  const getLoanAmountSchemeDetails = async (amount, savedSchemeCode = "") => {
    setCallInProgress(true);

    const result = await apiHandler({
      url: endpoint.GET_LOAN_SCHEME_DETAILS_API + amount + "&schemeChannel=NEW",
      authToken: authToken,
    });

    setCallInProgress(false);

    console.log(result?.data, "scheme details");

    if (result?.data?.length > 0) {
      setSchemeDetails(result.data);
      // const cibilData = await getCustomerCibil();   
      const cibilTenureType = "DAYS"
      const filteredSchemes = result.data.filter((item) => {
        if (cibilTenureType?.toUpperCase() === "DAYS") {
          return (
            item?.tenureType?.toUpperCase() === "DAYS"
          );
        }
      //   if(cibilTenureType?.toUpperCase() === "MONTH") {
      //   return (
      //     item?.tenureType?.toUpperCase() === "MONTH"
      //   );
      // }
      });
      setSchemeDetails(filteredSchemes);
      const dataArr = filteredSchemes.map((item) => ({
        value: item?.code,
        label: `${item?.name}-${item?.code}-${item?.tenure}-${item.tenureType}-${item?.annualInterestRateMax}`,
      }));
      setSchemeList(dataArr);
      const savedScheme = filteredSchemes.find(
        (item) => item.code === savedSchemeCode
      );
      const selectedScheme = savedScheme || filteredSchemes[0];
      if (selectedScheme) {
        setLoanScheme(selectedScheme.code);
        await getLoanMaturityDate(
          selectedScheme.code,
          amount,
          selectedScheme
        );
      }
    } else {
      toastUpdate("Error", result?.data?.user_description, true);
    }
  };
  const handleLoanSchemeChange = async (selectedSchemeCode) => {
    setLoanScheme(selectedSchemeCode);

    const selectedScheme = schemeDetails.find(
      (scheme) => scheme.code === selectedSchemeCode
    );

    if (selectedScheme) {
      await getLoanMaturityDate(selectedSchemeCode, loanAmount, selectedScheme);
    }
  };

  const handleNext = () => {
    saveUserGeneralDetails();
  };
  const isFormValid = () => {
    if (disaledFields) return true; // Skip validation if fields are disabled

    const isLoanAmountInvalid = Number(loanAmount) > Number(maxLoanAmount);
    return loanScheme && isLoanAmountInvalid;
  };
  const loanPaymentDetails = async (
    schemeCode,
    amount,
    maturityTenure,
    maturityTenureType,
    schemeData
  ) => {
    setCallInProgress(true);

    const result = await apiHandler({
      url:
        endpoint.GET_LOAN_PAYMENT_DETAILS_API +
        leadId +
        "/" +
        schemeCode +
        `?loanAmount=${amount}`,
      method: "POST",
      authToken: authToken,
    });

    setCallInProgress(false);

    if (result?.data?.loanAmount) {
      setTransferTobank(result?.data?.netDisbursalAmount);
      setTotalCharges(result?.data?.totalCharges);

      parseLoanChargesData(result.data.loanSchemeCalculation);

      // Use tenure from maturity API
      setTenure(maturityTenure);
      setTenureType(maturityTenureType);

      setRateOfInterest(
        schemeData?.annualInterestRateMax || schemeData?.interestRate
      );

      await fetLoanDetails(false, maturityTenure, maturityTenureType);
    } else {
      toastUpdate("Error", result?.data?.user_description, true);
    }
  };
  const getLoanMaturityDate = async (schemeCode, amount, schemeData) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.LOAN_MATURITY_DATE + leadId + `?schemeCode=${schemeCode}`,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
      return;
    }
    const maturityTenure = result?.data?.tenure;
    const maturityTenureType = result?.data?.tenureType;
    setMaturityDate(result?.data?.maturityDate);
    setTenure(maturityTenure);
    setTenureType(maturityTenureType);
    await loanPaymentDetails(
      schemeCode,
      amount,
      maturityTenure,
      maturityTenureType,
      schemeData
    );
  };
  const saveUserGeneralDetails = async () => {
    // setCallInProgress(true);
    // const res = await apiHandler({
    //   url: endpoint.USER_LEAD_DETAILS_UPDATE_API + leadId,
    //   method: "PUT",
    //   authToken: authToken,
    //   data: {
    //     maturityDate: maturityDate,
    //   },
    // });
    // if (res?.data?.error_code) {
    //   toastUpdate("Error", res.data.user_description, true);
    //   setCallInProgress(false);
    // } else {
    //   setCallInProgress(false);
      navigate("/journey/RepaymentScheduleDetails", {
        state: { loanAmount: loanAmount, loanScheme: loanScheme },
      });
    // }
  };
  const parseLoanChargesData = (data) => {
    const reportData = [];
    console.log(data, "fsdkfsdhb");
    data?.forEach((item, index) => {
      const gstAmount =
        Number(item.cgstAmount || 0) +
        Number(item.sgstAmount || 0) +
        Number(item.igstAmount || 0);

      console.log(data, gstAmount, "fsdkfsdhb11");
      reportData.push({
        id: index + 1,
        chargeType: toCamelCase(item.chargeType),
        adjustedAmount: formatAmount(item.adjustedAmount),
        adjustedAmountWithoutGst: formatAmount(item.adjustedAmountWithoutGst),
        gstAmount: formatAmount(gstAmount),
      });
    });

    setLoanChargesTableData(reportData);
  };
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader label="Loan Tenure Details" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Eligible Loan Amount (₹)"
              placeholder="Eligible Loan Amount (₹)"
              value={maxLoanAmount}
              onChange={(e) => setMaxLoanAmount(e.target.value)}
              style={classes.inputField}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Loan Required (₹)"
              placeholder="Loan Required (₹)"
              value={loanAmount}
              onChange={(e) => setLoanAmount(e.target.value)}
              onBlur={(e) => {
                getLoanAmountSchemeDetails(e.target.value);
              }}
              style={classes.inputField}
              disabled={disaledFields}
              type="number"
              helperText={
                !disaledFields &&
                loanAmount &&
                parseInt(loanAmount) > parseInt(maxLoanAmount)
                  ? "Loan Amount cannot be more than the Max Amount."
                  : ""
              }
              error={
                !disaledFields &&
                loanAmount &&
                parseInt(loanAmount) > parseInt(maxLoanAmount)
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelect
              label="Loan Scheme"
              value={loanScheme}
              onChange={(e) => handleLoanSchemeChange(e.target.value)}
              options={schemeList}
              style={classes.documentSelectBox}
              disabled={disaledFields}
            />
          </Grid>
        </Grid>
      </Grid>
      <Paper className={classes.card} elevation={0}>
        <div className={classes.cardHeader}>
          <div className={classes.headerIcon}>
            <DescriptionOutlinedIcon />
          </div>
          <div>
            <Typography className={classes.title}>Loan Summary</Typography>

            <Typography className={classes.subtitle}>
              Overview of your loan and applicable charges
            </Typography>
          </div>
        </div>
        <div className={classes.summaryGrid}>
          <div className={classes.summaryItem}>
            <div>
              <Typography className={classes.label}>Loan Amount</Typography>
              <Typography className={classes.value}>
                {formatAmount(loanAmount)}
              </Typography>
            </div>
          </div>
          <div className={classes.summaryItem}>
            <div>
              <Typography className={classes.label}>Tenure</Typography>
              <Typography className={classes.value}>
                {`${tenure || ""} ${tenureType || ""}`}
              </Typography>
            </div>
          </div>
          <div className={classes.summaryItem}>
            <div>
              <Typography className={classes.label}>
                Rate of Interest
              </Typography>
              <Typography className={classes.value}>
                {rateOfInterest / 360}%
              </Typography>
            </div>
          </div>
          <div className={classes.summaryItem}>
            <div>
              <Typography className={classes.label}>Total Interest</Typography>
              <Typography className={classes.value}>
                {formatAmount(totalInterest)}
              </Typography>
            </div>
          </div>
          <div className={classes.summaryItem}>
            <div>
              <Typography className={classes.label}>
                Transfer To Bank
              </Typography>
              <Typography className={classes.value}>
                {formatAmount(transferToBank)}
              </Typography>
            </div>
          </div>
        </div>
      </Paper>
      <Paper className={classes.card} elevation={0}>
        <div className={classes.cardHeader}>
          <div className={classes.headerIcon}>
            <ReceiptOutlinedIcon />
          </div>
          <div>
            <Typography className={classes.title}>Charge Breakdown</Typography>
            <Typography className={classes.subtitle}>
              Detailed breakup of total charges
            </Typography>
          </div>
        </div>
        <TableContainer>
          <Table>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell>Charge Type</TableCell>
                <TableCell align="right">Base Amount (₹)</TableCell>
                <TableCell align="right">GST Amount (₹)</TableCell>
                <TableCell align="right">Total Amount (₹)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loanChargesTableData.map((row) => {
                return (
                  <TableRow key={row.id}>
                    <TableCell className={classes.tableCell}>
                      {row.chargeType}
                    </TableCell>

                    <TableCell className={classes.tableCell} align="right">
                      {row.adjustedAmountWithoutGst}
                    </TableCell>

                    <TableCell className={classes.tableCell} align="right">
                      {row.gstAmount}
                    </TableCell>

                    <TableCell className={classes.tableCell} align="right">
                      {row.adjustedAmount}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Divider />

        <div className={classes.totalRow}>
          <span>Total Charges</span>
          <span>{formatAmount(totalCharges)}</span>
        </div>
      </Paper>
      <Grid item xs={12}>
        <BottomButton
          button1="Next"
          button1click={handleNext}
          disabled1={isFormValid()}
        />
      </Grid>
         {toast && (
                <ToastModal
                  toastMessage={toastMessage}
                  toastMessageType={toastMessageType}
                  toastUpdate={toastUpdate}
                />
              )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default LoanTenureDetails;